import { ReactNode } from 'react';

interface CustomTooltipProps {
  show: boolean;
  content: string | ReactNode;
  children: ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
}

export const CustomTooltip = ({
  show,
  content,
  children,
  position = 'top',
}: CustomTooltipProps) => {
  const getPositionClasses = () => {
    switch (position) {
      case 'top':
        return 'bottom-full left-1/2 -translate-x-1/2 mb-3';
      case 'bottom':
        return 'top-full left-1/2 -translate-x-1/2 mt-3';
      case 'left':
        return 'right-full top-1/2 -translate-y-1/2 mr-3';
      case 'right':
        return 'left-full top-1/2 -translate-y-1/2 ml-3';
      default:
        return 'bottom-full left-1/2 -translate-x-1/2 mb-3';
    }
  };

  const positionClasses = getPositionClasses();

  return (
    <div className="relative  inline-block w-full">
      {show && (
        <div className={`absolute ${positionClasses} z-10`}>
          <div className="bg-[var(--color-tooltip-background)] border border-[var(--color-tooltip-border)] rounded-md px-3 py-2 shadow-lg text-sm whitespace-nowrap">
            {content}
          </div>
        </div>
      )}
      {children}
    </div>
  );
};
